import { useEffect, useState } from "react";
import __ from "underscore";
import EnvironmentalMetrics from "./EnvironmentalMetrics";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { getTenantDropDownList } from "../../store/thunk/tenantThunk";
import {
  getAllDevices,
  getConfiguredDevicesNew,
} from "../../store/thunk/deviceThunk";
import { Box, useTheme, useMediaQuery, LinearProgress, Alert, IconButton } from "@mui/material";
import TenantDropdownMenu from "./customeTenantDropdown";
import { detectionAggSubstanceList as detectionAggSubstanceListBlank } from "../../store/slices/substanceSlice";
import { getLocationLists } from "../../store/thunk/locationThunk";
import { setTenantId } from "../../store/thunk/commonThunk";
import { LocationDataDeviceByType } from "../../helper/service";
import { getAggMeasurements } from "../../store/thunk/substanceThunk";
import { getCategoryList, getSubstabceConfiguration } from "../../store/thunk/categorySubstanceThunk";
import { SubstancesIcons } from "../../constants";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import DetectionDetailsComponent from "./detectionDetail";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  getDetectionAggMeasurements,
  getDetectionDetailsDataThunk,
  getSingleSubstanceFrequencyThunk,
} from "../../store/thunk/detection";
import moment from "moment";
import DetectionDetailsSkeleton from "./detectionSkeleton/substanceTilesSkeleton";
import { setLoader, setNewDashboardLoader } from "../../store/slices/authSlice";
import { setActiveLocarionRow, setDetectionDetialsGraphData } from "../../store/slices/detectionSlice";
import CustomHeader from "../pageHeader/Index";
import DropdownMenu from "./customeDropdown";

const DetectionComponent = () => {
  const { substanceKey } = useParams();
  const [searchParams] = useSearchParams();
  const selectedValueFacility = searchParams.get("facility");
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useAppDispatch();
  const [tenant, setTenant] = useState("");
  const [tenantListDropdown, setTenantListDropdown] = useState([]);
  const items = JSON.parse(localStorage.getItem("tenantId") || "{}");
  const { userData } = useAppSelector((state) => state.authReducer);
  const { tenantDropDownList } = useAppSelector((state) => state.tenantSlice);
  const { locationList } = useAppSelector((state) => state?.locationSlice);
  const { loading, newDashboardLoader } = useAppSelector((state) => state.authReducer);
  const {
    detectionDetialsData,
    detectionSingleSubstanceFrequencyData,
    loaderDetectionDetialsData,
    detectionMeasurementNotFound,
  } = useAppSelector((state: any) => state.detection);
  const [aggMeasureList, setAggMeasureList] = useState<any>({});
  const [detectionDetailList, setDetectionDetailList] = useState<any>([]);
  const [selectedValue, setSelectedValue] = useState<any>({
    substanceKey: "",
    displayName: "",
  });
  const [filterValue, setFilterValue] = useState<any>({
    facilityKey: "",
    floorKey: "",
  });
  const [sortValue, setSortValue] = useState<any>("fcl");
  const [locations, setLocations] = useState<any>({
    facilities: "",
    floors: "",
    rooms: "",
  });
  const { detectionMeasurementLoading, detectionAggSubstanceList, substanceConfigurationList } = useAppSelector(
    (state: any) => state.substanceSlice
  );
  const { categoryList, categoryLoading } = useAppSelector(
    (state) => state.categorySubstanceSlice
  );
  const [dateRange, setDateRangeChange] = useState<any>({
    startDate: moment().startOf("minute").subtract(3, "hour"),
    endDate: moment().startOf("minute"),
  });

  const handleChange = (event: any) => {
    const value = event.target.value;
    const tenantData = tenantDropDownList?.getTenants?.tenants;
    const currentTenant = tenantData.find(
      (item: any) => item.tenantId == value
    );
    let request = {
      tenantId: currentTenant.tenantCode,
    };
    dispatch(getLocationLists(request));
    dispatch(detectionAggSubstanceListBlank([]));
    dispatch(getConfiguredDevicesNew({ tenantCode: currentTenant.tenantCode }));
    dispatch(
      getSubstabceConfiguration({
        tenantCode:
          currentTenant.tenantCode,
      })
    );
    dispatch(getCategoryList({ request: { tenantCode: currentTenant.tenantCode } }));
    dispatch(setTenantId(currentTenant));
    setTenant(value);
  };
  useEffect(() => {
    dispatch(detectionAggSubstanceListBlank([]));
    // dispatch(getAllDevices({}));
    dispatch(getTenantDropDownList({}));
    if (items && items.tenantId) {
      dispatch(getConfiguredDevicesNew({ tenantCode: items && items.tenantId ? items.tenantCode : userData.tenantCode, }));
      dispatch(
        getSubstabceConfiguration({
          tenantCode:
            items && items.tenantId ? items.tenantCode : userData.tenantCode,
        })
      );
      dispatch(getCategoryList({ request: { tenantCode: items && items.tenantId ? items.tenantCode : userData.tenantCode } }));
    }
  }, []);
  useEffect(() => {
    let obj: any = {
      name: userData.name,
      tenantCode: userData.tenantCode,
      tenantId: userData.tenantId,
    };
    let request = {
      tenantId:
        items && items.tenantId ? items.tenantCode : userData.tenantCode,
    };
    if (userData.tenantId) {
      dispatch(getLocationLists(request));
      dispatch(
        getConfiguredDevicesNew({
          tenantCode:
            items && items.tenantId ? items.tenantCode : userData.tenantCode,
        })
      );

      dispatch(
        getSubstabceConfiguration({
          tenantCode:
            items && items.tenantId ? items.tenantCode : userData.tenantCode,
        })
      );
      dispatch(getCategoryList({ request: { tenantCode: items && items.tenantId ? items.tenantCode : userData.tenantCode } }));
      setTenant(obj);

    } else {
      if (!__.isEmpty(userData?.tenant_info)) {
        const lastTenantInfo = JSON.parse(userData?.tenant_info);
        setTenant(lastTenantInfo.tenantId);
        let request = {
          tenantId: lastTenantInfo.tenantCode,
        };
        if (locationList.length === 0) {
          dispatch(getLocationLists(request));
        }
      }
    }
  }, [userData])
  useEffect(() => {
    if (
      tenantDropDownList &&
      tenantDropDownList.getTenants &&
      tenantDropDownList?.getTenants?.tenants.length
    ) {
      setTenantListDropdown(tenantDropDownList?.getTenants?.tenants);
    }
  }, [tenantDropDownList]);

  useEffect(() => {
    if (substanceConfigurationList.length > 0 && detectionAggSubstanceList.length > 0 && detectionAggSubstanceList[0]?.readings?.length) {
      const latestArr = substanceConfigurationList.map((item: any) => {
        const config =
          (detectionAggSubstanceList.length > 0 &&
            detectionAggSubstanceList[0].readings.find(
              (val: any) =>
                val.substanceKey === item.substanceKey ||
                (val.substanceKey === "pm10" && item.substanceKey === "pm10m")
            )) ||
          undefined;
        let color = "#C7C6C1";
        let value = null;
        let value1 = null;
        let count = "0";
        let icon = SubstancesIcons[item.substanceKey] || "Cloud_light";
        let trend = "";
        let isoIndex = "-";
        if (config !== undefined) {
          color = config.color || "#C7C6C1";
          value = config.value;
          value1 = config.value1;
          count = config.count;
          trend = config.trend;
          isoIndex = config.isoIndex;
        }
        return {
          ...item,
          color: color,
          value: value,
          value1: value1,
          count: count,
          trend: trend,
          icon: icon,
          isoIndex,
        };
      });
      setAggMeasureList(latestArr?.filter((item: any) => !!item?.value));
    } else {
      setAggMeasureList({});
    }        
  }, [detectionAggSubstanceList, substanceConfigurationList]);

  useEffect(() => {
    if (locationList && locationList?.getLocations) {
      const locationData = LocationDataDeviceByType(locationList?.getLocations);                 
      if (Object.keys(locationData).length) {
        const systems = locationList?.getLocations.filter(
          (item: any) => item.type === "S"
        );
        if (systems.length) {
          let facilities: any = [];
          let floors: any = [];
          let rooms: any = [];
          systems.map((Stm: any) => {
            if (locationData["F"] && locationData["F"][Stm.key]) {
              facilities = [...facilities, ...locationData["F"][Stm.key]];
            }
          });
          if (facilities.length) {
            facilities.map((key: any) => {
              if (locationData["L"] && locationData["L"][key]) {
                floors = [...floors, ...locationData["L"][key]];
              }
            });
          }
          if (floors.length) {
            floors.map((key: any) => {
              if (locationData["R"] && locationData["R"][key]) {
                rooms = [...rooms, ...locationData["R"][key]];
              }
            });
          }
          if (facilities.length && rooms.length) {
            const request = {
              level: "loc",
              loctionKeys: rooms?.join(","),
              facilityKey: facilities?.join(","),
            };
            setLocations({
              facilities: facilities?.join(","),
              floors: floors?.join(","),
              rooms: rooms?.join(","),
            });
            dispatch(getDetectionAggMeasurements({request:request, tenantCode : items && items.tenantId ? items.tenantCode : userData.tenantCode}))
          }
        }
      }
    } else {
      setLocations({
        facilities: "",
        floors: "",
        rooms: "",
      });
    }
  }, [locationList, substanceKey]);

  const getSingleSubstanceDetail = () => {
    const requestParams = {
      substances:
        selectedValue.substanceKey !== ""
          ? selectedValue.substanceKey
          : substanceKey,
      fromDate: moment(dateRange.startDate).format("Y-MM-DD HH:mm:ssZ"),
      toDate: moment(dateRange.endDate).format("Y-MM-DD HH:mm:ssZ"),
      facilityKey: locations.facilities,
      loctionKeys: locations.rooms,
      level: "loc",
      sorDirection: "DESC"
    };
    const requestParams1 = {
      tenantCode:
        items && items.tenantId ? items.tenantCode : userData.tenantCode,
      substance:
        selectedValue.substanceKey !== ""
          ? selectedValue.substanceKey
          : substanceKey,
      loctionKeys: locations.rooms,
      startDate: moment.utc(dateRange.startDate).valueOf(),
      endDate: moment.utc(dateRange.endDate).valueOf(),
    };
    if (
      requestParams.substances !== "" &&
      requestParams.facilityKey !== "" &&
      requestParams.loctionKeys !== ""
    ) {
      dispatch(setLoader(true))
      dispatch(setNewDashboardLoader(true))
      dispatch(getDetectionDetailsDataThunk({request:requestParams, tenantCode:items && items.tenantId ? items.tenantCode : userData.tenantCode})).then(() => {
        dispatch(setLoader(false))
        dispatch(setNewDashboardLoader(false))
      });
      dispatch(getSingleSubstanceFrequencyThunk(requestParams1));
    }
  };
  const DetectionDetailPage = (data: any) => {
    navigate(`/element-detection/${data.substanceKey}`);
  };
  useEffect(() => {
    if (substanceKey) {
      getSingleSubstanceDetail();

    }
  }, [substanceKey, locations]);

  useEffect(() => {
    if (
      locationList &&
      locationList?.getLocations &&
      detectionDetialsData.length > 0
    ) {
      const locationD = locationList?.getLocations;
      const substdKey = selectedValue.substanceKey !== "" ? selectedValue.substanceKey : substanceKey
      const substanceData =
        (substanceConfigurationList.length > 0 &&
          substanceConfigurationList.find(
            (val: any) => val.substanceKey == substdKey
          )) ||
        [];
      const latestArr = detectionDetialsData.map((item: any, index: any) => {

        const facilityD =
          locationD.find((val: any) => val.key == item.fcl) || undefined;
        const floorD =
          locationD.find((val: any) => val.key == item.flr) || undefined;
        const roomD =
          locationD.find((val: any) => val.key == item.loc) || undefined;
        const frequencyData =
          detectionSingleSubstanceFrequencyData.find(
            (vlc: any) => vlc.device_loc === item.loc
          ) || {};
        let facilityName = "";
        let floorName = "";
        let roomName = "";

        if (facilityD !== undefined && facilityD.name !== undefined) {
          facilityName = facilityD.name;
        }
        if (floorD !== undefined && floorD.name !== undefined) {
          floorName = floorD.name;
        }
        if (roomD !== undefined && roomD.name !== undefined) {
          roomName = roomD.name;
        }
        return {
          ...item,
          ...substanceData,
          facilityName: facilityName,
          floorName: floorName,
          roomName: roomName,
          frequencyData: frequencyData,
        };
      });

      const Detectiondata = latestArr.sort((a: any, b: any) => sortValue === 'fcl' ? (a?.facilityName.toString()).localeCompare(b?.facilityName.toString()) : (b?.[sortValue].toString()).localeCompare(a?.[sortValue].toString()));
      if (filterValue.facilityKey !== "" && filterValue.floorKey !== "") {
        const newArr = Detectiondata.filter((item: any) => item.fcl === filterValue.facilityKey && item.flr === filterValue.floorKey)
        setDetectionDetailList(newArr);
        return;
      } else if (filterValue.facilityKey !== "" && filterValue.floorKey === "") {
        const newArr = Detectiondata.filter((item: any) => item.fcl === filterValue.facilityKey)
        setDetectionDetailList(newArr);
        return;
      } else {
        setDetectionDetailList(Detectiondata);
        return;
      }
    } else if (detectionDetialsData.length === 0) {
      setDetectionDetailList([]);
    }
  }, [
    detectionDetialsData,
    locationList,
    substanceConfigurationList,
    detectionSingleSubstanceFrequencyData,
    sortValue,
    filterValue
  ]);

  useEffect(() => {
    if (selectedValue.substanceKey !== "") {
      dispatch(setActiveLocarionRow(""))
      getSingleSubstanceDetail();
      dispatch(setDetectionDetialsGraphData([]))
      // dispatch(setActiveLocarionRow(""))
    }
  }, [selectedValue]);
  useEffect(() => {
    let start: any = "";
    let end: any = "";
    let hoursDiff: any = 0;
    let daysDiff: any = 0;

    if (typeof dateRange?.startDate === "string") {
      start = moment(dateRange?.startDate);
      end = moment(dateRange?.endDate);
      hoursDiff = end.diff(start, "hours");
      daysDiff = end.diff(start, "days");
    } else {
      start = dateRange?.startDate;
      end = dateRange?.endDate;
      hoursDiff = end.diff(start, "hours");
      daysDiff = end.diff(start, "days");
    }
    // dispatch(setDetectionDetialsGraphData([]))
    // dispatch(setActiveLocarionRow(""))
    getSingleSubstanceDetail();
  }, [dateRange]);
  const backPage = () => {
    dispatch(setDetectionDetialsGraphData([]))
    dispatch(setActiveLocarionRow(""))
    setSelectedValue({
      substanceKey: "",
      displayName: "",
    })
    setFilterValue({
      facilityKey: "",
      floorKey: "",
    })
    navigate(`/element-detection`);
  };

  const handleFacilityFilter = (values: any) => {
    if (values.target.name === "facilityKey") {
      setFilterValue(
        {
          ...filterValue,
          "floorKey": "",
          [values.target.name]: values.target.value
        }
      )
    } else {
      setFilterValue(
        {
          ...filterValue,
          [values.target.name]: values.target.value
        }
      )
    }
  };
  const optionFacilityList = (locationList?.getLocations && locationList?.getLocations.length > 0) && locationList?.getLocations.reduce((acc: any, val: any) => {
    if (val.type === "F") {
      acc.push({ ...val, label: val.name, value: val.key });
    }
    return acc;
  }, []);

  const optionFloorList = (locationList?.getLocations && locationList?.getLocations.length > 0) && locationList?.getLocations.reduce((acc: any, val: any) => {
    if (val?.type === "L" && val?.is_unit === false && filterValue.facilityKey === val.parentKey) {
      acc.push({ ...val, label: val.name, value: val.key });
    }
    return acc;
  }, []);
  return (
    <>
      <CustomHeader component={
        (substanceKey && <IconButton onClick={() => backPage()}>
          <ArrowBackIcon />
        </IconButton>
        )
      } title={"Detection"}>
        {userData.group === 'admin' && !substanceKey && (
          <Box
            sx={{
              display: isMobile ? "block" : "flex",
              alignItems: "center",
              gap: 0.5,
              marginTop: "14px",
              whiteSpace: "nowrap",
              justifyContent: isMobile ? "center" : "flex-start",
            }}
          >
            <TenantDropdownMenu
              title={"Select Tenant"}
              name={"tenant"}
              selectedValue={tenant}
              handleChange={handleChange}
              options={tenantListDropdown}
            />
          </Box>
        )}

        {substanceKey && (
          <>
            <Box
              sx={{ width: { xs: "100%", md: "23em", alignItems: "end" }, mt: 2 }}
            >
              <DropdownMenu
                title={"Facility"}
                name={"facilityKey"}
                handleChange={handleFacilityFilter}
                options={optionFacilityList}
                selectedValue={filterValue.facilityKey || selectedValueFacility}
              />
            </Box>
            <Box
              sx={{ width: { xs: "100%", md: "23em", alignItems: "end" }, mt: 2 }}
            >
              <DropdownMenu
                title={"Floor"}
                name={"floorKey"}
                handleChange={handleFacilityFilter}
                options={optionFloorList}
                selectedValue={filterValue.floorKey}
              />
            </Box>
          </>)
        }

      </CustomHeader>
      {!substanceKey && detectionMeasurementLoading &&
        <>
          <LinearProgress color="secondary" />
          <Box sx={{ p: 2, width: "100%", mx: "auto" }}>
            <DetectionDetailsSkeleton title={""} tilesCount={4} />
            <DetectionDetailsSkeleton title={"Particulates"} tilesCount={5} />
            <DetectionDetailsSkeleton title={"Bio"} tilesCount={7} />
            <DetectionDetailsSkeleton title={"Gases"} tilesCount={8} />
            <DetectionDetailsSkeleton title={"Chemicals"} tilesCount={10} />
          </Box>
        </>
      }
      {!substanceKey && (detectionMeasurementNotFound || (locationList?.getLocations && locationList?.getLocations.length === 0)) &&
        <Box sx={{ p: 2, pb: 0, display: 'flex', gap: 2, width: "100%" }}>
          <Alert severity="warning" sx={{ width: '100%', fontSize: '1rem' }}>
            Data not available...!
          </Alert>
        </Box>
      }
      {substanceKey ? (
        <DetectionDetailsComponent
          data={detectionDetailList}
          setSelectedValue={setSelectedValue}
          selectedValue={selectedValue}
          setDateRangeChange={setDateRangeChange}
          dateRange={dateRange}
          substanceKey={substanceKey}
          sortValue={sortValue}
          newDashboardLoader={newDashboardLoader}
          setSortValue={setSortValue}
          categoryList={categoryList}
        />
      ) : (!detectionMeasurementLoading && Object.keys(aggMeasureList).length > 0 &&
        <EnvironmentalMetrics
          aggMeasureList={aggMeasureList}
          categoryList={categoryList}
          detectionDetailPage={DetectionDetailPage}
        />
      )}
    </>
  );
};

export default DetectionComponent;
